import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useCurrentSite } from '@hotjar/site';
import { PageHeader as Header, tokens } from '@hotjar/hotsauce';
import { SegmentDropdownMenu } from './SegmentDropdownMenu';
import type { SegmentDropdownMenuProps } from './SegmentDropdownMenu';
import { DEFAULT_SEGMENT } from '@hotjar/webapp/domains/segments/constant';
import type { ReactNode } from 'react';

const Container = styled.div`
  margin: 0 ${tokens.spacer.x4} ${tokens.spacer.x2};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type PageHeaderProps = SegmentDropdownMenuProps & { subtitle: ReactNode | string } & {
  children: ReactNode;
};

export function PageHeader({
  onDeleteSegment,
  onEditSegment,
  onEditSlackForwarding,
  segment,
  children,
}: PageHeaderProps): JSX.Element | null {
  const { t } = useTranslation();
  const currentSite = useCurrentSite().data;

  if (!currentSite) {
    return null;
  }

  // apply translation only to default segments with negative index
  const title =
    segment && segment.id !== DEFAULT_SEGMENT.id
      ? segment.id < 0
        ? t(segment.name)
        : segment.name
      : t('common:recordings.list.page-title');
  return (
    <Container>
      <Header
        title={title}
        actions={
          segment &&
          !segment.read_only && (
            <>
              <SegmentDropdownMenu
                kind="secondary"
                onDeleteSegment={onDeleteSegment}
                onEditSegment={onEditSegment}
                onEditSlackForwarding={onEditSlackForwarding}
                segment={segment}
              />
            </>
          )
        }
      />
      {children}
    </Container>
  );
}
